module.exports = __webpack_public_path__ + "img/ai-thumbnail.6e1034c4.webp";